// extracted by mini-css-extract-plugin
module.exports = {"homepage":"Homepage-module--homepage--2-CD0"};